export function Reset({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.83109 3.81078C7.48359 3.61578 8.20359 3.48828 8.99859 3.48828C12.5911 3.48828 15.5011 6.39828 15.5011 9.99078C15.5011 13.5833 12.5911 16.4933 8.99859 16.4933C5.40609 16.4933 2.49609 13.5833 2.49609 9.99078C2.49609 8.65578 2.90109 7.41078 3.59109 6.37578"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.90234 3.99L8.06984 1.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.90234 3.99023L8.42984 5.83523"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
